import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';

import '../Resources/dashboard.css';
import axios from '../../axios.js';
import moment from 'moment/moment';
import Sidebar from './sidebar.js';
import Navbar from './navbar.js';

function Newcrm_createlead(){



  
   //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const editId=sessionStorage.getItem("EditId00");
 const counterid=sessionStorage.getItem("CounterId00");


 //Checking if Sessions are Set

// alert(logstatus,loguser,logadminid);
 //Sessions Not Set
 {/* if(((logstatus==null)||(logstatus==""))||((logid==null)||(logid==""))||((token==null)||(token==" "))||((busyid==null)||(busyid==" "))||((counterid==null)||(counterid==" "))){
  
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");
   
 
    window.location.replace("/businesstools-login");
   }
  
   //Sessions Set
   else{

   */}

    
      
//Variables
const[Tbanks,setTbanks] = useState([]);//SetData Variable
const[customers,setcustomers] = useState([],);//SetData Variable
const[cdefault,setcdefault] = useState(0);

//Error Variable
const[errorvar,seterrorvar] = useState();

//customers_count
const[customers_count,setcustomers_count] = useState(1);
//csuccess
//const[ccsuccess,setccsuccess] = useState(0);
//date



//cid
const[cid,setcid]=useState();const updatecid = (event) => { setcid(event.target.value);}; const[cid_er,setcid_er]=useState();
//customer_id
const[customer_id,setcustomer_id]=useState();const updatecustomer_id = (event) => { setcustomer_id(event.target.value);}; const[customer_id_er,setcustomer_id_er]=useState();
//first_name
const[first_name,setfirst_name]=useState();const updatefirst_name = (event) => { setfirst_name(event.target.value);}; const[first_name_er,setfirst_name_er]=useState();
//last_name
const[last_name,setlast_name]=useState();const updatelast_name = (event) => { setlast_name(event.target.value);}; const[last_name_er,setlast_name_er]=useState();
//email
const[email,setemail]=useState();const updateemail = (event) => { setemail(event.target.value);}; const[email_er,setemail_er]=useState();
//contact
const[contact,setcontact]=useState();const updatecontact = (event) => { setcontact(event.target.value);}; const[contact_er,setcontact_er]=useState();
//whatsapp
const[whatsapp,setwhatsapp]=useState();const updatewhatsapp = (event) => { setwhatsapp(event.target.value);}; const[whatsapp_er,setwhatsapp_er]=useState();
//city
const[city,setcity]=useState();const updatecity = (event) => { setcity(event.target.value);}; const[city_er,setcity_er]=useState();
//cstate
const[cstate,setcstate]=useState();const updatecstate = (event) => { setcstate(event.target.value);}; const[cstate_er,setcstate_er]=useState();
//followup_date
const[followup_date,setfollowup_date]=useState();const updatefollowup_date = (event) => { setfollowup_date(event.target.value);}; const[followup_date_er,setfollowup_date_er]=useState();
//followup_time
const[followup_time,setfollowup_time]=useState();const updatefollowup_time = (event) => { setfollowup_time(event.target.value);}; const[followup_time_er,setfollowup_time_er]=useState();
//business_type
const[business_type,setbusiness_type]=useState();const updatebusiness_type = (event) => { setbusiness_type(event.target.value);}; const[business_type_er,setbusiness_type_er]=useState();
//consulting_for
const[consulting_for,setconsulting_for]=useState();const updateconsulting_for = (event) => { setconsulting_for(event.target.value);}; const[consulting_for_er,setconsulting_for_er]=useState();
//interested_in
const[interested_in,setinterested_in]=useState();const updateinterested_in = (event) => { setinterested_in(event.target.value);}; const[interested_in_er,setinterested_in_er]=useState();
//category
const[category,setcategory]=useState();const updatecategory = (event) => { setcategory(event.target.value);}; const[category_er,setcategory_er]=useState();
//sub_category
const[sub_category,setsub_category]=useState();const updatesub_category = (event) => { setsub_category(event.target.value);}; const[sub_category_er,setsub_category_er]=useState();
//action
const[action,setaction]=useState();const updateaction = (event) => { setaction(event.target.value);}; const[action_er,setaction_er]=useState();
//followup_mode
const[followup_mode,setfollowup_mode]=useState();const updatefollowup_mode = (event) => { setfollowup_mode(event.target.value);}; const[followup_mode_er,setfollowup_mode_er]=useState();
//lead_stage
const[lead_stage,setlead_stage]=useState();const updatelead_stage = (event) => { setlead_stage(event.target.value);}; const[lead_stage_er,setlead_stage_er]=useState();
//lead_type
const[lead_type,setlead_type]=useState();const updatelead_type = (event) => { setlead_type(event.target.value);}; const[lead_type_er,setlead_type_er]=useState();
//service_status
const[service_status,setservice_status]=useState();const updateservice_status = (event) => { setservice_status(event.target.value);}; const[service_status_er,setservice_status_er]=useState();
//customer_status
const[customer_status,setcustomer_status]=useState();const updatecustomer_status = (event) => { setcustomer_status(event.target.value);}; const[customer_status_er,setcustomer_status_er]=useState();
//lead_remarks
const[lead_remarks,setlead_remarks]=useState();const updatelead_remarks = (event) => { setlead_remarks(event.target.value);}; const[lead_remarks_er,setlead_remarks_er]=useState();
//next_followup_date
const[next_followup_date,setnext_followup_date]=useState();const updatenext_followup_date = (event) => { setnext_followup_date(event.target.value);}; const[next_followup_date_er,setnext_followup_date_er]=useState();
//next_followup_time
const[next_followup_time,setnext_followup_time]=useState();const updatenext_followup_time = (event) => { setnext_followup_time(event.target.value);}; const[next_followup_time_er,setnext_followup_time_er]=useState();

//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();




useEffect(()=>{
   
  getData();
  
  },[])
 

  
    
  
//******************* GET BANKS DATA FUNCTION START  ********************//
function getData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((editId!=null)||(editId!=" "))){
 
 
 axios.post("newcrm-customer-info", {
   Log_id:logid,
   Token:token,
  // Busy_id:busyid,
   Edit_id:editId,

 })
 .then((response) => {

  console.log(response.data);

  setcid(editId);

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("EditId00");


     window.location.replace("/");
  }
  //Success Data Fetched
  if(response.data.successvar==1){

   //Setting Data
   setcid(response.data.cid);
   setcustomer_id(response.data.customer_id);
   setfirst_name(response.data.first_name);
   setlast_name(response.data.last_name);
   setcontact(response.data.contact);
   setemail(response.data.email);
   setwhatsapp(response.data.whatsapp);
   setbusiness_type(response.data.business_type);
   setcity(response.data.city);
   setcstate(response.data.state);
   setcategory(response.data.category);
   setsub_category(response.data.sub_category);
   setconsulting_for(response.data.consulting_for);
   setinterested_in(response.data.interested_in);
   setfollowup_date(response.data.followup_date);
   setfollowup_time(response.data.followup_time);
   setaction(response.data.action);
   setfollowup_mode(response.data.followup_mode);
   setlead_stage(response.data.lead_stage);
   setlead_type(response.data.lead_type);
   setnext_followup_date(response.data.next_followup_date);
   setnext_followup_time(response.data.next_followup_time);
   setlead_remarks(response.data.lead_remarks);
   
  
  }
  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* GET BANKS DATA FUNCTION END  ********************//



//******************* CREATE NEW LEAD FUNCTION START ********************//
function createnewlead(){

  //Setting Error Variables
setcid_er(" ");setcustomer_id_er(" ");setfirst_name_er(" ");setlast_name_er(" ");setemail_er(" ");setcontact_er(" ");setwhatsapp_er(" ");setcity_er(" ");setcstate_er(" ");
setfollowup_date_er(" ");setfollowup_time_er(" ");setbusiness_type_er(" ");setconsulting_for_er(" ");setinterested_in_er(" ");setcategory_er(" ");setsub_category_er(" ");setaction_er(" ");
setfollowup_mode_er(" "); setlead_stage_er(" ");setlead_type_er(" ");setlead_remarks_er(" ");setfollowup_date_er(" ");setfollowup_time_er(" ");


//Checking if user loggedin
if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))/*&&((busyid!=null)||(busyid!=" "))&&((counterid!=null)||(counterid!=" "))*/){
 
 
  axios.post("newcrm-create-newlead", {
   Log_id:logid,
   Token:token,
 /*  Busy_id:busyid,
   Counter_id:counterid, */
   Cid:cid,
   Customer_id:customer_id,
   First_name:first_name,
   Last_name:last_name,
   Email:email,
   Contact:contact,
   Whatsapp:whatsapp,
   City:city,
   State:cstate,
   Followup_date:moment(followup_date).format('YYYY-MM-DD'),
   Followup_time:followup_time,
   Business_type:business_type,
   Consulting_for:consulting_for,
   Interested_in:interested_in,
   Category:category,
   Sub_category:sub_category,
   Action:action,
   Followup_mode:followup_mode,
   Lead_stage:lead_stage,
   Lead_type:lead_type,
   Service_status:"active",
   Customer_status:"active",
   Lead_remarks:lead_remarks,
   Next_followup_date:moment(next_followup_date).format('YYYY-MM-DD'),
   Next_followup_time:next_followup_time,
 })
 .then((response) => {

  console.log(response.data);
  
  //Invalid Entries
 
  if(response.data.error==103){     seterror_msg(response.data.error_msg);  return; }

  if(response.data.error==111){     seterror_msg(response.data.error_msg); return; }
  
  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");

     window.location.replace("/");

  }

   //Validation Errors
 if(response.data.validatorerror){
  setcustomer_id_er(response.data.validatorerror.Customer_id);
  setfirst_name_er(response.data.validatorerror.First_name);
  setlast_name_er(response.data.validatorerror.Last_name);
  setemail_er(response.data.validatorerror.Email);
  setcontact_er(response.data.validatorerror.Contact);
  setwhatsapp_er(response.data.validatorerror.Whatsapp);
  setcity_er(response.data.validatorerror.City);
  setcstate_er(response.data.validatorerror.State);
  setfollowup_date_er(response.data.validatorerror.Followup_date);
  setfollowup_time_er(response.data.validatorerror.Followup_time);
  setbusiness_type_er(response.data.validatorerror.Business_type);
  setconsulting_for_er(response.data.validatorerror.Consulting_for);
  setinterested_in_er(response.data.validatorerror.Interested_in);
  setcategory_er(response.data.validatorerror.Category);
  setsub_category_er(response.data.validatorerror.Sub_category);
  setaction_er(response.data.validatorerror.Action);
  setfollowup_mode_er(response.data.validatorerror.Followup_mode);
  setlead_stage_er(response.data.validatorerror.Lead_stage);
  setlead_type_er(response.data.validatorerror.Lead_type);
  setservice_status_er(response.data.validatorerror.Service_status);
  setcustomer_status_er(response.data.validatorerror.Customer_status);
  setlead_remarks_er(response.data.validatorerror.Lead_remarks);
  setnext_followup_date_er(response.data.validatorerror.Next_followup_date);
  setnext_followup_date_er(response.data.validatorerror.Next_followup_date);

  return;

}
//Invalid Entries
if(response.data.error==102){ 
  
  setcustomer_id_er(response.data.customer_id_er);
  setfirst_name_er(response.data.first_name_er);
  setlast_name_er(response.data.last_name_er);
  setemail_er(response.data.email_er);
  setcontact_er(response.data.contact_er);
  setwhatsapp_er(response.data.whatsapp_er);
  setcity_er(response.data.city_er);
  setcstate_er(response.data.state_er);
  setfollowup_date_er(response.data.followup_date_er);
  setfollowup_time_er(response.data.followup_time_er);
  setbusiness_type_er(response.data.business_type_er);
  setconsulting_for_er(response.data.consulting_for_er);
  setinterested_in_er(response.data.interested_in_er);
  setcategory_er(response.data.category_er);
  setsub_category_er(response.data.sub_category_er);
  setaction_er(response.data.action_er);
  setfollowup_mode_er(response.data.followup_mode_er);
  setlead_stage_er(response.data.lead_stage_er);
  setlead_type_er(response.data.lead_type_er);
  setservice_status_er(response.data.service_status_er);
  setcustomer_status_er(response.data.customer_status_er);
  setlead_remarks_er(response.data.lead_remarks_er);
  setnext_followup_date_er(response.data.next_followup_date_er);
  setnext_followup_date_er(response.data.next_followup_date_er);
 
  seterror_msg("Cannot Add Transaction!");  return; }

   

   //Transaction Entered Successfully
   if(response.data.successvar==1){        sessionStorage.setItem("Trno00",response.data.Tr_no); document.getElementById("success-card").style.display="block";  }
   //Cannot Add Transaction
   else{  seterror_msg("Cannot Add Transaction !"); }
  

});
}
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");


   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* CREATE SALES FUNCTION END ********************//






return(
    <>


    <html lang="en">
      <head>
        {/*} Required meta tags */}
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <title>BUSINESS SAMADHAN | CRM</title>
        {/*} plugins:css */}
        <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
        <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
        <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
        {/*} endinject */}
        {/*} Plugin css for this page */}
        <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
        <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
        {/*} End plugin css for this page */}
        {/*} inject:css */}
        {/*} endinject */}
        {/*} Layout styles */}
        <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
        {/*} End layout styles */}
        <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
      </head>
      <body>
    
    
        <div class="container-scroller">
    
        <Sidebar />
        <div class="container-fluid page-body-wrapper">
    
    
    
    
           <Navbar />
            {/*} partial */}
            <div class="main-panel">
    
              {/* ADD CUSTOMER SUCCESS CARD START */}
              <div class="d-flex justify-content-center">
              <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="card-title  text-success">New Lead Added Successfully !!!</h4>
                      
                        <blockquote class="blockquote">
                          <p class="mb-0"> Click the following button to close.</p>
                          <a href="newcrm-customers-list"><button class="mt-3 btn btn-outline-danger">Close</button></a>
                        </blockquote>
                      </div>
                  
                    </div>
                  </div>
                  </div>
                  {/* ADD CUSTOMER SUCCESS CARD END */}
    
               
              
    
              <div class="content-wrapper pb-0">
    
              
                 {/* CREATE TEAM FORM START */}
                        <div class="row">
                            <div class="col-12 grid-margin">
                         


                <div class="card">
                <div class="d-flex justify-content-between">
                    <div></div>
                    <div>
                    
                      <button type="button" class="btn btn-social-icon" onClick={()=>{ window.location.replace("newcrm-customerslist") }}>
                      <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                      </button>
                      </div>
                    </div>
                  <div class="card-body">
                    <h4 class="card-title">Create New Lead</h4>
                    <div class="form-sample">
                      <p class="card-description">add your lead information here</p>
                      <code>{error_msg}</code>
                    
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Cid</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="01" id="cid" value={cid} onChange={updatecid} />
                            <code>{cid_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Customer Id</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="CUST00001" id="customer_id" value={customer_id} onChange={updatecustomer_id} />
                            <code>{customer_id_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">First Name</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Suman" id="first_name" value={first_name} onChange={updatefirst_name}/>
                              <code>{first_name_er}</code>
                           {/*}   <button class="btn btn-light" hidden={firsts_count>0} onClick={addfirst}>Add this as new customer ....</button>
                              <p class="text-success" style={{display:"none"}} id="cst-customer"><b>New Customer Added!</b></p> */}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Last Name</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Soni" id="last_name" value={last_name} onChange={updatelast_name} />
                            <code>{last_name_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Email</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Sumansonisharma34@gmail.com" id="email" value={email} onChange={updateemail} />
                            <code>{email_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Contact</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="91 8000000000" id="contact" value={contact} onChange={updatecontact} />
                            <code>{contact_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">WhatsApp</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="91 8000000000" id="whatsapp" value={whatsapp} onChange={updatewhatsapp} />
                              <code>{whatsapp_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Business Type</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="business" id="business_type" value={business_type} onChange={updatebusiness_type} />
                              <code>{business_type_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">City</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Lucknow" id="city" value={city} onChange={updatecity} />
                              <code>{city_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">State</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Uttar Pradesh" id="cstate" value={cstate} onChange={updatecstate} />
                              <code>{cstate_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Consulting For</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="MSME Subsidy"  id="consulting_for" value={consulting_for} onChange={updateconsulting_for}/>
                              <code>{consulting_for_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Interested In</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" pincode="Private Limited, DPIIT" id="interested_in" value={interested_in} onChange={updateinterested_in} />
                              <code>{interested_in_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Followup Date</label>
                            <div class="col-sm-9">
                              <input type="date" class="form-control" placeholder="India"  id="followup_date" value={followup_date} onChange={updatefollowup_date}/>
                              <code>{followup_date_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Followup Time</label>
                            <div class="col-sm-9">
                              <input type="time" class="form-control" pincode="420110" id="followup_time" value={followup_time} onChange={updatefollowup_time} />
                              <code>{followup_time_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Category</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="regular"  id="category" value={category} onChange={updatecategory}/>
                              <code>{category_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Sub Category</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" pincode="online" id="sub_category" value={sub_category} onChange={updatesub_category} />
                              <code>{sub_category_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Action</label>
                            <div class="col-sm-9">
                              <select class="form-control" placeholder="India"  id="action" value={action} onChange={updateaction} style={{padding:"1rem"}}>
                              <option value=" ">select action</option>
                              <option value="primary enquiry">primary enquiry</option>
                              <option value="message received">message received</option>
                              <option value="message sent">message sent</option>
                              <option value="payment request">payment request</option>
                              <option value="consultancy">consultancy</option>
                              <option value="payment done">payment done</option>
                              <option value="service assigned">service assigned</option>
                              <option value="service completion">service completion</option>
                              </select>
                              <code>{action_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Followup Mode</label>
                            <div class="col-sm-9">
                              <select class="form-control" pincode="420110" id="followup_mode" value={followup_mode} onChange={updatefollowup_mode} style={{padding:"1rem"}}>
                              <option value=" ">select mode</option>
                              <option value="whatsapp">whatsapp</option>
                              <option value="phone call">phone call</option>
                              <option value="message">message</option>
                              <option value="online meeting">online meeting</option>
                              <option value="offline meeting">offline meeting</option>
                              <option value="other">other</option>
                              </select>
                              <code>{followup_mode_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Lead Stage</label>
                            <div class="col-sm-9">
                              <select class="form-control" placeholder="India"  id="lead_stage" value={lead_stage} onChange={updatelead_stage} style={{padding:"1rem"}}>
                              <option value=" ">select lead stage</option>
                              <option value="sales enquiry">sales enquiry</option>
                              <option value="followup">followup</option>
                              <option value="near conversion">near conversion</option>
                              <option value="service started">service started</option>
                              <option value="not converted">not converted</option>
                              <option value="service completed">service completed</option>
                              </select>
                              <code>{lead_stage_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Lead Type</label>
                            <div class="col-sm-9">
                              <select class="form-control" pincode="420110" id="lead_type" value={lead_type} onChange={updatelead_type} style={{padding:"1rem"}}>
                              <option value=" ">select lead type</option>
                              <option value="hot">hot</option>
                              <option value="cold">cold</option>
                              <option value="normal">normal</option>
                              </select>
                              <code>{lead_type_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                   {/*}   <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Service Status</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="India"  id="service_status" value={service_status} onChange={updateservice_status}/>
                              <code>{service_status_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Customer Status</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" pincode="420110" id="customer_status" value={customer_status} onChange={updatecustomer_status} />
                              <code>{customer_status_er}</code>
                            </div>
                          </div>
                        </div>
                      </div> */}
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Next Followup Date</label>
                            <div class="col-sm-9">
                              <input type="date" class="form-control" placeholder="India"  id="next_followup_date" value={next_followup_date} onChange={updatenext_followup_date}/>
                              <code>{next_followup_date_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Next Followup Time</label>
                            <div class="col-sm-9">
                              <input type="time" class="form-control" pincode="420110" id="next_followup_time" value={next_followup_time} onChange={updatenext_followup_time} />
                              <code>{next_followup_time_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="exampleTextarea1">Lead Remarks</label>
                        <textarea  class="form-control" rows="2" placeholder="Add your Remarks here" id="lead_remarks" value={lead_remarks} onChange={updatelead_remarks} />
                        <code>{lead_remarks_er}</code>
                      </div>
                    
                        
                      
                        <button class="btn btn-primary" style={{fontWeight:"bold"}} onClick={createnewlead}>Create Lead</button>
                      
                       
    
                     
                   
                    </div>
                  </div>
                </div>
                 {/* CREATE TEAM FORM END */}

                        
                        </div>
                    </div>
                 
                   
            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
        {/*}  <footer class="footer">
            <div class="d-sm-flex justify-content-center justify-content-sm-between">
              <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i class="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
    </>

);

}
//}

export default Newcrm_createlead;